import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll() {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: '/sites'
      }))
  );
}

async function getById(siteID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/sites/${siteID}`
      }))
  );
}

async function create(site) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/sites',
        body: JSON.stringify(site)
      }))
  );
}

async function update(site) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/sites/${site.siteID}`,
        body: JSON.stringify(site)
      }))
  );
}

// lowercase delete is a reserved word in javascript
async function Delete(siteID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/sites/${siteID}`
      }))
  );
}

const siteService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete
};

export default siteService;
